query CorporateWorkgroupsData($filter: CorporateWorkgroupFilter) {
  corporateWorkgroups(filter: $filter, orderBy: WORKGROUP_NUMBER_ASC) {
    nodes {
      id
      name
      workgroupNumber
    }
  }
}
